import { Controller } from "stimulus"

// Auto-growing textarea. Starts at one line, grows as content is added.
// Usage: data-controller="auto-grow" data-action="input->auto-grow#resize"
export default class extends Controller {
  connect() {
    this.element.style.overflow = "hidden"
    this.element.style.resize = "none"
    this.element.style.boxSizing = "border-box"

    // Panel toggles and viewport changes can wrap text without an input event.
    this._widthObserver = new ResizeObserver(([entry]) => {
      if (entry.contentRect.width === this._observedWidth) return
      this._observedWidth = entry.contentRect.width
      cancelAnimationFrame(this._resizeFrame)
      this._resizeFrame = requestAnimationFrame(() => this.resize())
    })
    this._widthObserver.observe(this.element)

    this.resize()
    setTimeout(() => this.resize(), 50)
    setTimeout(() => this.resize(), 200)
    setTimeout(() => this.resize(), 1000)

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.resize())
    }

    // Re-measure when editor settings (font size, family, etc.) change
    this._onSettingsChanged = () => {
      setTimeout(() => this.resize(), 50)
      setTimeout(() => this.resize(), 200)
    }
    document.addEventListener("editor-settings:changed", this._onSettingsChanged)
  }

  disconnect() {
    this._widthObserver?.disconnect()
    cancelAnimationFrame(this._resizeFrame)
    document.removeEventListener("editor-settings:changed", this._onSettingsChanged)
  }

  resize() {
    const el = this.element
    if (!el.offsetParent && !el.offsetHeight) return

    el.style.height = "auto"
    el.rows = 1
    const borders = el.offsetHeight - el.clientHeight
    el.style.height = (el.scrollHeight + borders) + "px"
  }
}
